import { Hidden } from '@material-ui/core';
import React, { useContext } from 'react';
import { getGpsType } from '../../helpers/gps-helper';
import { DemographicsContext } from '../../models/demographics-model';
import { GuidedProcessSupportBlock } from '../guided-process-support-block';
import { GpsType, LayoutModels } from '../layout/layout-models';
import { MainContent } from '../layout/main-content-container';
import { PageContainer } from '../layout/page-container';
import { SideBarContent } from '../layout/sidebar-content';


export const withLayout = (layout: LayoutModels = LayoutModels.RIGHT_SIDE_BAR, gpsType = GpsType.NONE) => (WrappedComponent: React.ComponentType) => {

    return (props: React.PropsWithChildren<any>) => {
        const app = useContext(DemographicsContext);

        const gpsItem = getGpsType(gpsType, app);


        switch (layout) {
            case LayoutModels.NO_LAY_OUT:
                return (
                    <WrappedComponent {...props}>
                        {props.children}
                    </WrappedComponent>
                );
            case LayoutModels.RIGHT_SIDE_BAR:
                return (
                    <>
                        <PageContainer>
                            <MainContent>
                                <WrappedComponent {...props}>
                                    {props.children}
                                </WrappedComponent>
                            </MainContent>
                            <Hidden smDown>
                                <SideBarContent>
                                    <GuidedProcessSupportBlock title={gpsItem?.title} contents={gpsItem?.contents} />
                                </SideBarContent>
                            </Hidden>
                        </PageContainer>
                    </>);
            case LayoutModels.FULL_WIDTH:
                return (
                    <PageContainer>
                        <MainContent fullWidth>
                            <WrappedComponent {...props}>
                                {props.children}
                            </WrappedComponent>
                        </MainContent>
                    </PageContainer>
                );

            default:
                return (
                    <>
                        <PageContainer>
                            <MainContent>
                                <WrappedComponent {...props}>
                                    {props.children}
                                </WrappedComponent>
                            </MainContent>
                            <Hidden smDown>
                                <SideBarContent>
                                    <GuidedProcessSupportBlock title={gpsItem?.title} contents={gpsItem?.contents} />
                                </SideBarContent>
                            </Hidden>
                        </PageContainer>
                    </>);
        }


    };
};





